export default {
  getQuoteSection: (state) => state.quoteSection,
};
